import React from "react";
import { useSelector } from "react-redux";

import AuthService, { ROLES_IDS } from "services/AuthService";
import { IconButton } from "components";

import { useAppDispatch, useAppSelector } from "store";
import { alertsViewSet, globalThemeSet, notificationsViewSet, selectIsNewAlerts, selectIsNewNotifications, selectTheme } from "slices/notificationsSlice";
import UserMenu from "./UserMenu";
import { StyledHeader, StyledRightArea, StyledIconButton } from "./styles";

const Header = () => {
  const { role } = AuthService.getUser();
  const dispatch = useAppDispatch();
  const isNewNotificationsExist = useAppSelector(selectIsNewNotifications);
  const isNewAlertsExist = useSelector(selectIsNewAlerts);
  const theme = useAppSelector(selectTheme);
  const notifyIcon = isNewNotificationsExist ? "notificationNew" : "notification";
  const alertIcon = isNewAlertsExist ? "warningNew" : "warning";
  const themeV = {"dark": "light", "light": "dark"};
  const isAdmin = role === ROLES_IDS.Admin;

  function toggleTheme() {
    dispatch(globalThemeSet(themeV[theme]));
    AuthService.toggleTheme(themeV[theme]);
  }

  function openNewNotifications() {
    dispatch(alertsViewSet(""));
    dispatch(notificationsViewSet(isNewNotificationsExist ? "new" : "all"));
  }

  function openNewAlerts() {
    dispatch(notificationsViewSet(""));
    dispatch(alertsViewSet(isNewAlertsExist ? "new" : "all"));
  }

  return (
    <StyledHeader>
      <StyledIconButton
        icon={theme === "dark" ? "themeDark" : "themeLight"}
        label="theme"
        color="primary"
        onClick={toggleTheme}
      />
      <StyledRightArea>
        {!isAdmin && (
          <>
            <IconButton
              icon={notifyIcon}
              transparent
              originalColors
              onClick={openNewNotifications}
            />
            <IconButton
              icon={alertIcon}
              transparent
              originalColors
              onClick={openNewAlerts}
            />
          </>
        )}
        <UserMenu />
      </StyledRightArea>
    </StyledHeader>
  );
};

export default Header;
